export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8271.8fafea56.jpg";